import { Navigate, Outlet, useLocation } from 'react-router-dom'
import useAuth from '../models/useAuth'

export default function AuthGuard() {
  const location = useLocation()
  const { session, initialized } = useAuth()

  if (!initialized) return null

  if (session) return <Outlet />

  return <Navigate to="/login" replace state={{ from: location }} />
}
